export const isProdServer = () => {
  return process.env.REACT_APP_API_URL === 'https://api.verqor.com/admin';
};

export const isDevServer = () => {
  return process.env.REACT_APP_API_URL === 'https://api-dev.verqor.com/admin';
};

export const isProdOrDevServer = () => {
  return isProdServer() || isDevServer();
};
